import { Survey, SearchResponse, SurveyById, SurveyData, Commodities } from "../../interfaces/dataInterfaces"
import { blobToDownload, transformResponse } from "../../utils/helpers"
import { mfiApi } from "./mfiApi"

export const survey = mfiApi.injectEndpoints({
  endpoints: builder => ({
    getSurveyMFIList: builder.query<
      SearchResponse<Survey>,
      { skip: number; top: number; adm0Code: number; search: string }
    >({
      query: query => ({
        url: `Survey/Get`,
        params: query,
        method: "GET",
      }),
      providesTags: ["SurveysMFI"],
    }),

    saveSurveyMFIFile: builder.mutation<{ fileName: string }, FormData>({
      query: body => ({
        url: "Survey/SaveCSVFile",
        method: "POST",
        body,
      }),
    }),

    validateSurveyMFI: builder.query<
      { isValid: boolean; validationResult: string },
      { fileName: string; adm0Code: number; xlsFormID: number }
    >({
      query: query => ({
        url: `Survey/ValidateSurvey`,
        params: query,
        method: "GET",
      }),
    }),

    validateSurveyMFIMinRequiredFields: builder.query<
      { isValid: boolean; validationResult: string; validationToken: string },
      { fileName: string; adm0Code: number; xlsFormID: number }
    >({
      query: query => ({
        url: `Survey/ValidateSurveyForMinimumRequiredFields`,
        params: query,
        method: "GET",
      }),
    }),

    saveSurveyMFI: builder.mutation<{ isSuccess: boolean; resultMessage: string; surveyId: number }, SurveyData>({
      query: body => ({
        url: "Survey/Save",
        method: "POST",
        body,
      }),
      invalidatesTags: ["SurveysMFI"],
    }),

    getSurveyMFI: builder.query<SurveyById, number>({
      query: id => ({
        url: `Survey/Get/${id}`,
        method: "GET",
      }),
    }),

    deleteSurveyMFI: builder.mutation<void, number>({
      query: id => ({
        url: `Survey/Delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["SurveysMFI"],
    }),

    listCommodityByBasketMFI: builder.query<Commodities[], { surveyId: number }>({
      query: query => ({
        url: `Survey/GetListCommodityBasket`,
        params: query,
        method: "GET",
      }),
    }),

    downloadSurveyFileMFI: builder.mutation<
      void,
      { dataType: string; surveyId: number; format: string; type?: string }
    >({
      query: ({ dataType, surveyId, format, type = "mfi" }) => {
        let url = `/Admin/Srvc/Proxy?u=apiget/MFI/Surveys/${dataType}?surveyID=${surveyId}&xlsFormType=${type}`
        if (format) url += `&format=${format}`
        return {
          url,
          responseHandler: async (response: Response) => {
            const res = await transformResponse(response, format)
            return res
          },
        }
      },
    }),

    downloadOriginSurveyMFI: builder.mutation<void, { surveyId?: number; file?: string }>({
      query: ({ file, surveyId }) => {
        return {
          url: "Survey/DownloadOriginSurvey",
          params: { surveyId, surveyOriginalFilename: file },
          method: "GET",
          responseHandler: async response => blobToDownload(response, `${file?.split(".csv_")[0]}.csv`),
        }
      },
    }),
  }),
})

export const {
  useGetSurveyMFIListQuery,
  useSaveSurveyMFIFileMutation,
  useValidateSurveyMFIQuery,
  useValidateSurveyMFIMinRequiredFieldsQuery,
  useSaveSurveyMFIMutation,
  useGetSurveyMFIQuery,
  useDeleteSurveyMFIMutation,
  useListCommodityByBasketMFIQuery,
  useDownloadSurveyFileMFIMutation,
  useDownloadOriginSurveyMFIMutation,
} = survey
